import { gql, useQuery } from '@apollo/client';
import React from 'react';
import { Link, useRouter } from '../../utils/router/v3Bridge';
import IconButton from '../../components/IconButton';
import StickyHeader from '../../components/StickyHeader';
import type {
  HistorySidebarPostQuery,
  HistorySidebarPostQueryVariables,
} from '../../graphql/generated/graphqlTypes';
import closeIcon from '../../icons/clear.svg';
import postPath from '../../utils/url/postPath';
import CommentHistory from '../comment/CommentHistory';
import styles from './HistorySidebar.module.scss';
import PostHistory from './PostHistory';

const POST_QUERY = gql`
  query HistorySidebarPost($id: ID!) {
    post(id: $id) {
      id
      title
      publishedAt
      ...postPath_post
    }
  }
  ${postPath.fragments.post}
`;

interface HistorySidebarProps {
  postId: string;
  tab: 'comments' | 'versions';
}

const HistorySidebar = ({ postId, tab }: HistorySidebarProps) => {
  const router = useRouter();

  const { data } = useQuery<
    HistorySidebarPostQuery,
    HistorySidebarPostQueryVariables
  >(POST_QUERY, { variables: { id: postId } });

  const post = data?.post;

  if (!post) return null;

  const basePath = postPath(post);

  return (
    <>
      <StickyHeader>
        <div className={styles.tabs}>
          <Link
            activeClassName={styles.active}
            className={styles.tab}
            to={`${basePath}/histories`}
          >
            Versions
          </Link>
          <Link
            activeClassName={styles.active}
            className={styles.tab}
            to={`${basePath}/comments`}
          >
            Comments
          </Link>
          <div className={styles.closeButtonContainer}>
            <IconButton
              applyNegativeMargin
              onClick={() => {
                router.push(basePath);
              }}
              size="large"
            >
              {closeIcon}
            </IconButton>
          </div>
        </div>
      </StickyHeader>
      <div className={styles.content}>
        {tab === 'comments' && <CommentHistory post={post} />}
        {tab === 'versions' && <PostHistory postId={postId} />}
      </div>
    </>
  );
};

export default HistorySidebar;
